import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const pageTitles = {
  en: 'UK Football Camps - Elite Football Camps in Oakham, England',
  es: 'Campamentos de Fútbol en Reino Unido - Campamentos de Fútbol de Élite en Oakham, Inglaterra',
  fr: 'Camps de Football au Royaume-Uni - Camps de Football d\'Élite à Oakham, Angleterre',
  it: 'Campi di Calcio nel Regno Unito - Campi di Calcio d\'Elite a Oakham, Inghilterra'
};

const metaDescriptions = {
  en: 'Elite football camps in Oakham, England. High Performance Clinic and Aston Villa Foundation programs for ages 10-17. Professional coaching, English immersion, and world-class facilities.',
  es: 'Campamentos de fútbol de élite en Oakham, Inglaterra. Programas de Clínica de Alto Rendimiento y Fundación Aston Villa para edades de 10-17 años. Entrenamiento profesional, inmersión en inglés e instalaciones de clase mundial.',
  fr: 'Camps de football d\'élite à Oakham, Angleterre. Programmes de Clinique Haute Performance et Fondation Aston Villa pour les 10-17 ans. Entraînement professionnel, immersion en anglais et installations de classe mondiale.',
  it: 'Campi di calcio d\'elite a Oakham, Inghilterra. Programmi di Clinica ad Alte Prestazioni e Fondazione Aston Villa per età 10-17. Allenamento professionale, immersione in inglese e strutture di classe mondiale.'
};

const DynamicTitle = () => {
  const { language } = useLanguage();

  useEffect(() => {
    // Update document title
    document.title = pageTitles[language] || pageTitles.en;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', metaDescriptions[language] || metaDescriptions.en);
    }

    // Update html lang attribute
    document.documentElement.lang = language;
  }, [language]);

  return null;
};

export default DynamicTitle;
